module.exports = __webpack_public_path__ + "static/media/hong-kong-house.23a0778e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/hong-kong-house.svg
// module id = 131
// module chunks = 0